const defaultTheme = {};
export default defaultTheme;
